import { formatLondonDateTime } from '@/shared/lib/utils/formatLondonDateTime';
import { UserShortInfo } from '@/shared/types/common';
import { UserAvatar } from '@/shared/ui/UserAvatar';

interface ILessonInfoProps {
  module: string;
  numberLesson: number;
  title: string;
  scheduledAt: string | null;
  endDate: string | null;
  moduleTeacher: UserShortInfo | null;
  lecturer: UserShortInfo | null;
}

export const LessonInfo = (props: ILessonInfoProps) => {
  const { module, scheduledAt, numberLesson, title, lecturer, moduleTeacher } = props;

  return (
    <div className="bg-red p-6 rounded-2xl">
      <div className="text-[#EFBBBB] inline-flex items-center gap-x-2">
        <p>{module}</p>
        {scheduledAt && <p>{formatLondonDateTime(scheduledAt)}</p>}
      </div>
      <h2 className="text-white text-[32px] font-medium mb-4">
        {numberLesson}. {title}
      </h2>
      {/* {(moduleTeacher || lecturer) && (
        <div className="flex items-center gap-x-4">
          {moduleTeacher && (
            <UserAvatar
              avatar={moduleTeacher.avatar}
              userName={`${moduleTeacher.firstName} ${moduleTeacher.lastName}`}
              href={`/staff/${moduleTeacher.id}`}
              textColor="white"
            />
          )}
          {lecturer && (
            <UserAvatar
              avatar={lecturer.avatar}
              userName={`${lecturer.firstName} ${lecturer.lastName}`}
              href={`/staff/${lecturer.id}`}
              textColor="white"
            />
          )}
        </div>
      )} */}
      {lecturer ? (
        <UserAvatar
          avatar={lecturer.avatar}
          userName={`${lecturer.firstName} ${lecturer.lastName}`}
          href={`/staff/${lecturer.id}`}
          textColor="white"
        />
      ) :
        moduleTeacher ? (
          <UserAvatar
            avatar={moduleTeacher.avatar}
            userName={`${moduleTeacher.firstName} ${moduleTeacher.lastName}`}
            href={`/staff/${moduleTeacher.id}`}
            textColor="white"
          />
        ) : null}
    </div>
  );
};
